export const IS_PROD = window.location.hostname === 'www.growthriveconnect.com';

export const SUBMIT_INTEREST_API_NAME: string = 'interest';
export const OPT_IN_API_NAME: string = 'optin';
export const UNSUBSCRIBE_API_NAME: string = 'unsubscribe';

export const UNKNOWN_PARTNER: string = 'UNKNOWN';
